import {
  SetFile,
  UPLOAD_LIMITS
} from '@/components/file-uploader/types/upload-types'

export function handleFileChange(
  event: React.ChangeEvent<HTMLInputElement>,
  setFile: SetFile
) {
  const selectedFile = event.target.files ? event.target.files[0] : null
  if (!selectedFile) return
  setFile(selectedFile)
}

export function validateFileSelection(files: File[]): {
  valid: boolean
  errors: string[]
} {
  if (files.length === 0) {
    return { valid: false, errors: ['No files selected'] }
  }

  const errors: string[] = []

  if (files.length > UPLOAD_LIMITS.MAX_FILES) {
    errors.push(`Maximum ${UPLOAD_LIMITS.MAX_FILES} files allowed.`)
  }

  const largeFiles = files.filter((f) => f.size > UPLOAD_LIMITS.MAX_FILE_SIZE)
  if (largeFiles.length > 0) {
    errors.push(
      `These files exceed ${UPLOAD_LIMITS.MAX_FILE_SIZE / (1024 * 1024)} MB: ${largeFiles
        .map((f) => f.name)
        .join(', ')}`
    )
  }

  return { valid: errors.length === 0, errors }
}
